import React from 'react';

import MessageBanner from './message-banner';

import { Message } from '../../graphql/schema';
import { useMessageVisibility } from '../../hooks/useMessageVisibility';

export interface MessageBoxProps {
  messages: Message[];
  children?: React.ReactNode;
}

const SingularMessage: React.FC<{ message: Message }> = ({ message }) => {
  const messageId = message?.id || '';

  const { isVisible, handleCloseMessage } = useMessageVisibility({
    messageId,
  });

  if (!isVisible || !message) return null;
  return <MessageBanner message={message} handleCloseMessage={handleCloseMessage} />;
};

const MessageBox: React.FC<MessageBoxProps> & {
  Before: React.FC<{ children?: React.ReactNode }>;
  After: React.FC<{ children?: React.ReactNode }>;
} = ({ messages, children }) => {
  const beforeChildren = React.Children.toArray(children).find(
    (child): child is React.ReactElement => React.isValidElement(child) && child.type === MessageBox.Before
  );

  const afterChildren = React.Children.toArray(children).find(
    (child): child is React.ReactElement => React.isValidElement(child) && child.type === MessageBox.After
  );

  return (
    <>
      {beforeChildren}

      {messages.map(message => (
        <SingularMessage message={message} key={message.id} />
      ))}

      {afterChildren}
    </>
  );
};

MessageBox.Before = function before({ children }) {
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};
MessageBox.After = function after({ children }) {
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

export default MessageBox;
